import type SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';

export const MAILBOX_QUOTA_EXCEEDED_INNER_RESPONSE_CODE = 'ErrorMoveCopyFailedMailboxQuotaExceeded';
const INNER_RESPONSE_CODE_MARKER = `Name="InnerErrorResponseCode">${MAILBOX_QUOTA_EXCEEDED_INNER_RESPONSE_CODE}`;

export function getMoveCopyErrorCode(
    responseMessage: SingleResponseMessage | undefined
): string | undefined {
    return responseMessage?.MessageXml?.includes(INNER_RESPONSE_CODE_MARKER)
        ? MAILBOX_QUOTA_EXCEEDED_INNER_RESPONSE_CODE
        : responseMessage?.ResponseCode;
}
